import axios from "axios";
import { useCaptcha } from "vue-app/composables/useCaptcha";

export const postInboxSendMessage = async (inboxConversationId: number, content: string) => {
  const response = await axios.post("/inbox/send-message", {
    inbox_conversation_id: inboxConversationId,
    content: content,
  });

  return response.data.data;
};

export const postInboxCreateConversation = async (
  typeId: number,
  content: string,
  allegroLogin: string,
  orderId: string,
  customerLogin: string
) => {
  const { executeRecaptcha } = useCaptcha();
  const token = await executeRecaptcha("INBOX");
  const response = await axios.post("/inbox/create-conversation", {
    type_id: typeId,
    content,
    captcha: token,
    allegro_login: allegroLogin,
    order_id: orderId,
    customer_login: customerLogin,
  });
  return response.data.data;
};
